import { render, staticRenderFns } from "./CreateTableComparative.vue?vue&type=template&id=0e31f940&scoped=true&"
import script from "./CreateTableComparative.vue?vue&type=script&lang=js&"
export * from "./CreateTableComparative.vue?vue&type=script&lang=js&"
import style0 from "./CreateTableComparative.vue?vue&type=style&index=0&id=0e31f940&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e31f940",
  null
  
)

export default component.exports